<chr-modal *transloco="let t" [closable]="true" palette="warning" size="s" (chr-modal-close)="returnToPage()">
  <chr-modal-header [title]="dialogData.title" [with-icon]="true"></chr-modal-header>
  <chr-modal-body>
    <p class="description">{{ t("COMMON.COLLECTIONS.UNSAVED_CHANGES.DESCRIPTION") }}</p>
  </chr-modal-body>
  <chr-modal-footer>
    <chr-button
      palette="neutral"
      variant="invisible"
      [label]="t('COMMON.COLLECTIONS.UNSAVED_CHANGES.ACTIONS.RETURN_TO_PAGE')"
      (chr-action)="returnToPage()"
    ></chr-button>
    <chr-button
      palette="accent"
      variant="primary"
      [label]="t('COMMON.COLLECTIONS.UNSAVED_CHANGES.ACTIONS.DISCARD_CHANGES')"
      (chr-action)="closeModal()"
    ></chr-button>
  </chr-modal-footer>
</chr-modal>
